// @ts-nocheck -- verbatim TAPP payroll UI compatibility boundary
import type { HTMLAttributes } from "react";
import { clsx } from "clsx";

export type BadgeVariant =
  | "default"
  | "accent"
  | "brand"
  | "success"
  | "warning"
  | "danger"
  | "info"
  | "outline";

const variantClasses: Record<BadgeVariant, string> = {
  default:  "bg-elevated text-foreground-muted",
  accent:   "bg-accent-subtle text-accent",
  brand:    "bg-brand-subtle text-foreground-muted",
  success:  "bg-success-subtle text-success",
  warning:  "bg-warning-subtle text-warning",
  danger:   "bg-danger-subtle text-danger",
  info:     "bg-info-subtle text-info",
  outline:  "border border-border text-foreground-muted",
};

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  className?: string;
  children: React.ReactNode;
  dot?: boolean;
}

export function Badge({
  variant = "default",
  className,
  children,
  dot = false,
  ...props
}: BadgeProps) {
  return (
    <span
      {...props}
      className={clsx(
        "inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium",
        variantClasses[variant],
        className,
      )}
    >
      {dot && (
        <span className="status-dot shrink-0 bg-current opacity-80" />
      )}
      {children}
    </span>
  );
}
